import React from 'react'

const AntiSocialBehaviour: React.FC = () => {
  return (
    <div>
      <h2 className="text-uppercase">Anti-Social Behaviour</h2>
      
      <div className="intro-section">
        <p>
          <strong>
            Use our handy Anti-Social Behaviour (ASB) tool to work out what is and what is not Anti-Social Behaviour, and what steps you need to take.
          </strong>
        </p>
      </div>

      <div className="alert alert-info mt-4">
        <h4>Coming Soon</h4>
        <p>The Anti-Social Behaviour reporting tool is currently under development. This page will provide:</p>
        <ul>
          <li>Interactive categories for different types of anti-social behaviour</li>
          <li>Step-by-step guidance on how to report incidents</li>
          <li>Information on what constitutes anti-social behaviour</li>
          <li>Support resources and contact information</li>
          <li>Diary sheets for ongoing monitoring</li>
        </ul>
        <p className="mb-0">
          <strong>In the meantime:</strong> If you need to report anti-social behaviour, please contact us directly at 0345 678 0555 or use our general contact form.
        </p>
      </div>

      <div className="mt-4">
        <h4>Emergency Contacts</h4>
        <div className="row">
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Emergency</h5>
                <p className="card-text">If you are in immediate danger</p>
                <h3 className="text-danger">999</h3>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Non-Emergency Police</h5>
                <p className="card-text">For reporting criminal activity</p>
                <h3 className="text-primary">101</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AntiSocialBehaviour